import logo from "../assets/logo.svg";
import logoBg from "../assets/logo-bg.svg";
import { ReactComponent as arrowDownIcon } from "../assets/icon-arrow-down.svg";
import { ReactComponent as arrowLeftIcon } from "../assets/icon-arrow-left.svg";
import { ReactComponent as arrowRightIcon } from "../assets/icon-arrow-right.svg";
import { ReactComponent as calendarIcon } from "../assets/icon-calendar.svg";
import { ReactComponent as checkIcon } from "../assets/icon-check.svg";
import { ReactComponent as deleteIcon } from "../assets/icon-delete.svg";
import { ReactComponent as moonIcon } from "../assets/icon-moon.svg";
import { ReactComponent as plusIcon } from "../assets/icon-plus.svg";
import { ReactComponent as sunIcon } from "../assets/icon-sun.svg";
import { ReactComponent as illustrationEmpty } from "../assets/illustration-empty.svg";

import AvatarImage from "../assets/image-avatar.jpg";
import bg from "../assets/bg.jpg";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  logo,
  logoBg,
  arrowDownIcon,
  arrowLeftIcon,
  arrowRightIcon,
  calendarIcon,
  checkIcon,
  deleteIcon,
  moonIcon,
  plusIcon,
  sunIcon,
  illustrationEmpty,
  AvatarImage,
  bg,
};
